
import AbstractLayout from '~pages/layouts/AbstractLayout.vue'
import UiBlank from '~pages/layouts/UiBlank'

let routeInfo = [
  {
    path: 'callback',
    name: 'CallBackMain',
    components: Object.assign({}, { header: UiBlank, footer: UiBlank, content: AbstractLayout }),
    beforeEnter: (to, from, next) => {
      console.log('member callback root beforeEnter', to, from)
      next()
    },
    meta: {
      authorized: false
    },
    children: [
      {
        path: 'enrolmentPaymentResult',
        name: 'EnrolmentPaymentResult',
        component: () => import(/* webpackChunkName: "page_callback" */ '~pages/contents/callback/AllatPayResult.vue'),
        beforeEnter: (to, from, next) => {
          console.log('NaverLoginCallBack beforeEnter', to, from)
          next()
        },
        meta: {
          authorized: false
        }
      },
      {
        path: 'enrolmentPaymentCancelResult',
        name: 'EnrolmentPaymentCancelResult',
        component: () => import(/* webpackChunkName: "page_callback" */ '~pages/contents/callback/AllatPayCancelResult.vue'),
        beforeEnter: (to, from, next) => {
          console.log('NaverLoginCallBack beforeEnter', to, from)
          next()
        },
        meta: {
          authorized: false
        }
      },
      {
        path: 'naver',
        name: 'NaverCallBack',
        component: () => import(/* webpackChunkName: "page_callback" */ '~pages/contents/callback/NaverLoginResult.vue'),
        beforeEnter: (to, from, next) => {
          console.log('NaverLoginCallBack beforeEnter', to, from)
          next()
        },
        meta: {
          authorized: false
        }
      },
      {
        path: 'nice',
        name: 'NiceCallBack',
        component: () => import(/* webpackChunkName: "page_callback" */ '~pages/contents/callback/NiceCallBack.vue'),
        beforeEnter: (to, from, next) => {
          console.log('NiceCallBack beforeEnter', to, from)
          next()
        },
        meta: {
          authorized: false
        }
      }
    ]
  }
]

export default routeInfo



// WEBPACK FOOTER //
// ./src/config/router/child/callback.js